import React from "react";
import { Dot } from "./StatusDot.styles";
import type { StatusDotProps } from "./StatusDot.types";

const StatusDot: React.FC<StatusDotProps> = ({ tone = "active", title }) => (
  <Dot
    $tone={tone}
    role={title ? "img" : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : "true"}
  />
);

export default StatusDot;
